import { authService } from '@oneblink/apps-react'
import React from 'react'
import { Button } from '../Page'

function LogOutButton({ children }: { children?: React.ReactNode }) {
  const logout = React.useCallback(async () => {
    console.log('logout')
    authService.logout()
    await authService.logoutHostedUI()
  }, [])

  return <Button onClick={logout}>{children || 'Log Out'}</Button>
}

export default LogOutButton
